import { UniversalSelectWithRHF } from 'components/common/Select/UniversalSelectWithRHF';
import { useIsSupplierPortalProductEditorFieldDisabled } from 'hooks/useUserState_utils';
import { useTranslation } from 'react-i18next';

export const BiologicalTargetField = () => {
  const { t } = useTranslation();
  const disabled = useIsSupplierPortalProductEditorFieldDisabled();
  return (
    <UniversalSelectWithRHF
      formId="private_attributes.data.biologicalTarget"
      label={t('forms.product.biologicalTarget.label')}
      creatable
      type="UX_BEAUTY_BIOLOGICAL_TARGET"
      sort="type"
      disabled={disabled}
    />
  );
};
